import { render, staticRenderFns } from "./MaisInfo.vue?vue&type=template&id=f05950c4&scoped=true"
import script from "./MaisInfo.vue?vue&type=script&lang=js"
export * from "./MaisInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f05950c4",
  null
  
)

export default component.exports